/*eslint-disable*/
export default {
    seconds: [
        0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.2, 1.4, 1.6, 1.8, 2, 2.5, 3, 3.5, 4, 4.5, 5, 6, 7, 8, 9, 10
    ],
    secondsForAddAndSub : [
        0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.2, 1.4, 1.6, 1.8, 2, 2.5, 3, 3.5, 4, 4.5, 5, 6, 7, 8, 9, 10
    ],
    digits: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    timeLimitValues: [0, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9, 10],
    timeLimitForMemorize: [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    timeLimitForFactorization: [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    secondsForMemoryGames: [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    secondsForDivideItRight: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    secondsForNavigator: [0.5, 0.7, 1, 1.2, 1.5, 1.7, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
    secondsForShutter: [
        0.1, 0.10909, 0.12, 0.13334, 0.150009, 0.17142, 0.2, 0.24, 0.3, 0.31575, 0.33337, 0.3529, 0.375, 0.4, 0.4286, 0.4615, 0.5, 0.5455, 0.6, 0.6665, 0.75, 0.857, 1, 1.2, 1.5, 2, 3, 6
    ],
    secondForMentalDrawing: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    timeLimitForMentalDrawing: [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
    timeLimitForHandsUp: [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
    numbersForAnagrams: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    playbackSpeedRate: [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2],
    bpmValues: [0, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250, 300, 350, 400, 450, 500]
}
